// extracted by mini-css-extract-plugin
module.exports = {"hero":"hero-module--hero--2dUwq","img":"hero-module--img--Kud9w"};